import { MoveStruct, normalizeMoveArguments } from "../utils/index.mjs";
import { bcs } from "@safecoin/safe/bcs";
//#region src/contracts/kiosk/royalty_rule.ts
/**************************************************************
* THIS FILE IS GENERATED AND SHOULD NOT BE MANUALLY MODIFIED *
**************************************************************/
/**
* Description: This module defines a Rule which requires a payment on a purchase.
* The payment amount can be either a fixed amount (min_amount) or a percentage of
* the purchase price (amount_bp). Or both: the higher of the two is used.
*
* Configuration:
*
* - amount_bp - the percentage of the purchase price to be paid as a fee,
*   denominated in basis points (100_00 = 100%, 1 = 0.01%).
* - min_amount - the minimum amount to be paid as a fee if the relative amount is
*   lower than this setting.
*
* Use cases:
*
* - Percentage-based Royalty fee for the creator of the NFT.
* - Fixed commission fee on a trade.
* - A mix of both: the higher of the two is used.
*
* Notes:
*
* - To use it as a fixed commission set the `amount_bp` to 0 and use the
*   `min_amount` to set the fixed amount.
* - To use it as a percentage-based fee set the `min_amount` to 0 and use the
*   `amount_bp` to set the percentage.
* - To use it as a mix of both set the `min_amount` to the min amount acceptable
*   and the `amount_bp` to the percentage of the purchase price. The higher of the
*   two will be used.
*/
const $moduleName = "@local-pkg/kiosk::royalty_rule";
new MoveStruct({
	name: `${$moduleName}::Rule`,
	fields: { dummy_field: bcs.bool() }
});
new MoveStruct({
	name: `${$moduleName}::Config`,
	fields: {
		amount_bp: bcs.u16(),
		min_amount: bcs.u64()
	}
});
/**
* Creator action: Add the Royalty Rule for the `T`. Pass in the `TransferPolicy`,
* `TransferPolicyCap` and the configuration for the policy: `amount_bp` and
* `min_amount`.
*/
function add(options) {
	const packageAddress = options.package ?? "@local-pkg/kiosk";
	const argumentsTypes = [
		null,
		null,
		"u16",
		"u64"
	];
	const parameterNames = [
		"policy",
		"cap",
		"amountBp",
		"minAmount"
	];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "royalty_rule",
		function: "add",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes, parameterNames),
		typeArguments: options.typeArguments
	});
}
/** Buyer action: Pay the royalty fee for the transfer. */
function pay(options) {
	const packageAddress = options.package ?? "@local-pkg/kiosk";
	const argumentsTypes = [
		null,
		null,
		null
	];
	const parameterNames = [
		"policy",
		"request",
		"payment"
	];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "royalty_rule",
		function: "pay",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes, parameterNames),
		typeArguments: options.typeArguments
	});
}
/**
* Helper function to calculate the amount to be paid for the transfer. Can be used
* dry-runned to estimate the fee amount based on the Kiosk listing price.
*/
function feeAmount(options) {
	const packageAddress = options.package ?? "@local-pkg/kiosk";
	const argumentsTypes = [null, "u64"];
	const parameterNames = ["policy", "paid"];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "royalty_rule",
		function: "fee_amount",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes, parameterNames),
		typeArguments: options.typeArguments
	});
}
//#endregion
export { add, feeAmount, pay };

//# sourceMappingURL=royalty_rule.mjs.map